import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import store from "store";
import { filterBigNumThousands } from "utils/method";

import XtFontScale from "components/xt/fontScale";

import styles from "./index.module.scss";

import { LayEnum } from "../index";

interface Props extends HTMLAttributes<HTMLDivElement> {
  ary: string[];
  depthType: LayEnum;
  maxAmount: number;
  openOrderObj: ObjAny;
}

const Main: React.FC<Props> = ({ className, ary, depthType, maxAmount, openOrderObj, ...rest }) => {
  // const router = useRouter();

  // const { currentConfig } = store.market;

  const docFormat = useMemo(() => {
    return {
      priceLab: filterBigNumThousands(ary[0]),
      amountLab: filterBigNumThousands(ary[1]),
      // priceLab: filterBigNumThousands(ary[0], currentConfig.pricePrecision),
      // amountLab: filterBigNumThousands(ary[1], currentConfig.quantityPrecision),
      totalLab: filterBigNumThousands(ary[2]),
    };
  }, [ary]);
  // }, [ary, currentConfig]);

  const handleClick = () => {
    store.trade.updateState({
      tradeRecentOnce: {
        p: ary[0],
        q: ary[1],
        total: ary[2],
        isClick: true,
      },
    });
  };

  const barStyle = useMemo(() => {
    const style: any = {};

    if (maxAmount) {
      style.width = (+ary[1] / maxAmount) * 100 + "%";
    }

    return style;
  }, [ary, maxAmount]);

  return (
    <div
      onClick={handleClick}
      className={cx(styles.main, [depthType === LayEnum.ask ? styles.ask : styles.bid], { [styles.atv]: !!openOrderObj[ary[0]] }, className)}
      {...rest}
    >
      <div style={barStyle}></div>
      <div>
        <XtFontScale>{docFormat.priceLab}</XtFontScale>
        <XtFontScale>{docFormat.amountLab}</XtFontScale>
        <XtFontScale>{docFormat.totalLab}</XtFontScale>
      </div>
    </div>
  );
};

export default observer(Main);
